export default {
  methods: {
    hasPermission(name) {
      const { userAuthorities } = this.$store.state;
      return userAuthorities.some((item) => item.name === name);
    },
    hasPermissionAll(names) {
      const nameArray = names.split(',').map((val) => val.trim());
      const { userAuthorities } = this.$store.state;
      return nameArray.some((name) => userAuthorities.some((item) => item.name === name));
    },
  },
};
